<template>
  <div class="no-drag">
    <div :class='{ "open": isMenuOpen, "dropdown": true }' v-on-clickaway='closeMenu'>
      <i class="far fa-ellipsis-v dropdown-toggle dots-icon"
         data-toggle="dropdown"
         aria-haspopup="true"
         aria-expanded="false"
         style="font-size:20px;"
         @click="isMenuOpen = !isMenuOpen" />
      <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-show='isMenuOpen'>
        <li v-for="(button, i) in buttons" :key="i"><router-link class="dropdown-item" :to="button.ref" @click.native='buttonAction(button)'>{{button.label}}</router-link></li>
        <li><a href="#" class="dropdown-item" v-if="hasOptions" @click="showSettingsDialog">Widget Settings</a></li>
        <li><a href="#" class="dropdown-item" v-if="!minimized" @click="toggleCollapse">Minimize</a></li>
        <li><a href="#" class="dropdown-item" v-if="minimized" @click="toggleCollapse">Restore</a></li>
      </ul>
    </div>
    <div class="dropdown open" v-if="showSettings" v-on-clickaway='hideSettingsDialog'>
      <ul class="dropdown-menu dropdown-menu-right width2x">
        <li><widget-options :options='options' :value="widget" @set="set" /></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'
  import { EventBus } from '@/event-bus'

  import WidgetOptions from './WidgetOptions'

  export default {
    mixins: [clickaway],

    props: ['widget', 'options'],

    data: function () {
      return {
        isMenuOpen: false,
        showSettings: false
      }
    },

    computed: {
      minimized() { return this.widget.isCollapsed },
      buttons() { return this.widget.actions },
      hasOptions() { return (this.widget.variables.length > 1) }
    },

    components: { WidgetOptions },

    created() {
      EventBus.$on('widgetSettingsClose', this.hideSettingsDialog)
    },

    methods: {
      closeMenu() { this.isMenuOpen = false },

      toggleCollapse() {
        this.closeMenu()
        this.$emit('toggleCollapse')
      },

      showSettingsDialog() {
        this.closeMenu()
        this.removeTopClass()
        this.showSettings = true
        this.$parent.$el.classList.toggle('top')
        this.bringWidgetToFront()
      },

      hideSettingsDialog() {
        this.showSettings = false
        this.$parent.$el.classList.remove('top')
      },

      bringWidgetToFront() {
        this.removeTopClass()
        this.$parent.$el.classList.add('alternateTop')
      },

      removeTopClass() {
        let element = document.querySelector('.alternateTop')
        if (element) element.classList.remove('alternateTop')
      },

      buttonAction(action) {
        this.closeMenu()

        if (action.action.includes('ReportDetails')) {
          EventBus.$emit('updateNavigatedAwayFrom', this.widget.id)
        }
      },

      set(v) {
        this.$emit('set', v)
      }
    }
  }
</script>

<style scoped lang="scss">

  @import "~@/assets/sass/_variables.scss";

  .dropdown-toggle {
    cursor: pointer;
    opacity: .3;
    font-size: 14px;
    border-radius: 5px;
    width: 30px;
    height: 30px;
    text-align: center;
    vertical-align: middle;
    padding-top: 6px;
    display: inline-block;
  }
  .dropdown-item{
    color: $main-black !important;
    &:hover{
       color: $main-black !important;
       background-color: $highlight-gray !important;
       box-shadow: none !important;
       padding: none !important;

    }
  }

    .dropdown-toggle:hover {
      opacity: 1;

      @include theme {
        background-color: v(background);
      }
    }

  .open .dropdown-toggle {
    opacity: 1;

    @include theme {
      background-color: v(background);
    }
  }

  .width2x {
    width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/SharedComponents/WidgetSettingsMenu.vue